// extracted by mini-css-extract-plugin
export default {"container":"TopComponent_container__ebo1y","specialP":"TopComponent_specialP__Z6yuw"};